import {
  Component,
  Inject,
  OnInit
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { Item } from '@sitecore-jss/sitecore-jss/layout';
import {
  FormFields
} from '../../../shared/services/form-fields-generator.service';

@Component({
  selector: 'ab-sentoo-payment-popup',
  templateUrl: './sentoo-payment-popup.component.html',
  styleUrls: ['./sentoo-payment-popup.component.scss']
})
export class SentooPaymentPopupComponent implements OnInit {


  public formFields: FormFields;
  public items: { [key: string]: Item };
  public challengeCode = 'NaN';
  public otpType: string;
  public approvalCodeErrorMessage: string;

  public approvalForm = new UntypedFormGroup({
    approvalCode: new UntypedFormControl(null, [
      Validators.required,
      Validators.pattern('[0-9]+')
    ])
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SentooPaymentPopupComponent>,
  ) {}


  ngOnInit() {

  }
}
